module.exports = __webpack_public_path__ + "static/periodontologia-2837eb8cb316060eb59ace53dac8b044.svg";